"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _lodash = require("lodash");
var _attachments = require("libs/utils/attachments");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var _require = require('src/branded-apps-metadata'),
  FORMS = _require.FORMS;
var languages = require('src/utils/languages');
var groupSidebarItemsById = function groupSidebarItemsById(sections) {
  return _.chain(sections).pluck('items').map(_.values).flatten(1).map(function (item) {
    return [item.id, item];
  }).object().value();
};
var EditAppCtrl = /* @ngInject */function EditAppCtrl($scope, $route, $routeParams, $location, $rootScope, $q, userService, modalService, appBrandingService, accountService, orgService) {
  var brandingId = $scope.brandingId = $routeParams.id;
  if (!brandingId) {
    $rootScope.navigate('/apps');
  }
  var branding = $scope.branding = {};
  $scope.saving = false;

  // Assets ------------------------------------------------------------------------------
  $scope.attachments = [];
  $scope.deleteAsset = function (name) {
    if (!confirm('Are you sure you want to delete this asset?')) {
      return;
    }
    return appBrandingService.deleteAsset($scope.branding, name).finally(function () {
      $scope.attachments = $scope.attachments.filter(function (n) {
        return n !== name;
      });
    });
  };
  function setOwnerName() {
    var _$scope$organisations;
    $scope.ownerName = (_$scope$organisations = $scope.organisations.find(function (org) {
      return org._id === $scope.vm.branding.fp_owner;
    })) === null || _$scope$organisations === void 0 ? void 0 : _$scope$organisations.display_name;
  }

  // App info ----------------------------------------------------------------------------
  $scope.organisations = [];
  orgService.getAllOrgs().then(function (response) {
    $scope.organisations = response.data;
    setOwnerName();
  });

  // Certificates ------------------------------------------------------------------------
  $scope.certificates = null;
  $scope.certificatesStore = '';
  $scope.userIsAppPublisher = userService.matchesRoles({
    globalRole: 'app_publisher'
  }, {
    globalRole: 'superadmin'
  });
  $scope.vm = {
    branding: branding
  };
  accountService.getUser($scope.user.email).then(function (result) {
    $scope.vm.userEvents = _.uniq(result.data.events, '_id');
    $scope.vm.userEventsIds = _.compact(_.pluck(result.data.events, '_id'));
  });

  /* Section switcher */

  var normalizedItem = function normalizedItem(conf) {
    return _.extend({
      visible: function visible() {
        return $scope.canEditApp;
      },
      hasChanged: function hasChanged() {
        return $scope.brandingHasChanged;
      },
      save: function save() {
        return $scope.saveBranding();
      },
      warnings: function warnings() {
        return [];
      }
    }, conf);
  };
  $scope.vm.configSections = {
    dashboard: {
      label: 'Overview',
      icon: 'icon-home',
      items: {
        dashboard: normalizedItem({
          id: 'dashboard',
          label: 'Dashboard',
          visible: function visible() {
            return true;
          },
          hasChanged: function hasChanged() {
            return false;
          }
        }),
        distribution: normalizedItem({
          id: 'distribution',
          label: 'Distribution'
        }),
        assets: normalizedItem({
          id: 'assets',
          label: 'Assets',
          hasChanged: function hasChanged() {
            return false;
          }
        })
      }
    },
    settings: {
      icon: 'icon-cogs',
      label: 'Build',
      items: {
        nameAndIcons: normalizedItem({
          id: 'app-info',
          label: 'Name, icon and splash screen',
          warnings: function warnings() {
            if (!_.size(branding)) {
              return [];
            }
            var warnings = [];
            if (_.isEmpty(branding.springboard_name)) {
              warnings.push('App name is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'appIcon')) {
              warnings.push('App icons is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'splashScreenPhone')) {
              warnings.push('Splash screen for phones is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'splashScreenTablet')) {
              warnings.push('Splash screen for tablets is missing');
            }
            return warnings;
          }
        }),
        theme: normalizedItem({
          id: 'app-theme',
          label: 'Theme',
          warnings: function warnings() {
            if (!_.size(branding)) {
              return [];
            }
            if (!_.size($scope.vm.theme)) {
              return [];
            }
            var warnings = [];
            if (!appBrandingService.getAssetInfo(branding, 'containerTheme') || !appBrandingService.getAssetInfo(branding, 'androidBrandingTheme')) {
              warnings.push('Theme is not configured');
            }
            if (!$scope.vm.theme.version) {
              warnings.push('Invalid theme. Please contact support.');
            }
            return warnings;
          },
          hasChanged: function hasChanged() {
            return $scope.themeHasChanged;
          },
          save: function save() {
            return $scope.saveTheme();
          }
        }),
        bundles: normalizedItem({
          id: 'bundle-ids',
          label: 'Bundles'
        }),
        appLock: normalizedItem({
          id: 'app-lock',
          label: 'Passcode'
        }),
        appDownloading: normalizedItem({
          id: 'downloads',
          label: 'Downloads'
        }),
        health: normalizedItem({
          id: 'healthkit',
          label: 'Health API'
        })
      }
    },
    activation: {
      icon: 'icon-users',
      label: 'Activation',
      items: {
        legal: normalizedItem({
          id: 'legal',
          label: 'Legal'
        }),
        activation: normalizedItem({
          id: 'activation-screen',
          label: 'Screens'
        }),
        invitations: normalizedItem({
          id: 'invitations',
          label: 'Invitations',
          visible: function visible() {
            return userService.hasPermission('app-brandings.app_publisher');
          }
        }),
        sso: normalizedItem({
          id: 'app-sso',
          label: 'Single Sign-On'
        }),
        i18n: normalizedItem({
          id: 'app-i18n',
          label: 'Translations'
        })
      }
    },
    emails: {
      icon: 'icon-email',
      label: 'Emails',
      items: {
        status: normalizedItem({
          id: 'email-status',
          label: 'Email status'
        }),
        invitation: normalizedItem({
          id: 'invitation-email',
          label: 'Invitation'
        }),
        account: normalizedItem({
          id: 'account-email',
          label: 'Create account'
        }),
        accountPasswordReset: normalizedItem({
          id: 'reset-account-password-email',
          label: 'Reset account password'
        }),
        appLockPasswordReset: normalizedItem({
          id: 'reset-app-lock-password-email',
          label: 'Reset Passcode'
        })
      }
    },
    store: {
      icon: 'icon-shop',
      label: 'Store',
      items: {
        info: normalizedItem({
          id: 'store-info',
          label: 'Listing',
          warnings: function warnings() {
            if (!_.size(branding)) {
              return [];
            }
            var warnings = [];
            var storeConfig = branding.store_config || {};
            _.each(FORMS.storeInfo, function (descriptor, field) {
              if (!descriptor.validations) {
                return;
              }
              var validations = descriptor.validations;
              if (validations.required && _.isEmpty(storeConfig[field])) {
                return warnings.push("".concat(descriptor.label, " is missing"));
              }
            });
            if (!appBrandingService.getAssetInfo(branding, 'iosStoreIcon')) {
              warnings.push('App Store icon is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'androidStoreIcon')) {
              warnings.push('Google Play icon is missing');
            }
            if (!appBrandingService.getAssetInfo(branding, 'androidFeatureGraphic')) {
              warnings.push('Google Play feature graphic is missing');
            }
            if (_.isEmpty(storeConfig.eid)) {
              warnings.push('Test event is missing');
            }
            if (_.isArray(storeConfig.keywords)) {
              var keywordsString = storeConfig.keywords.join(',');
              if (keywordsString.length > 100) {
                warnings.push('Too many keywords');
              }
              if (keywordsString.indexOf(' ') !== -1) {
                warnings.push('Keywords cannot contain a space');
              }
            }
            return warnings;
          }
        }),
        screenshots: normalizedItem({
          id: 'store-screenshots',
          label: 'Screenshots'
        }),
        // DISABLED until screenshot generator is up and running
        //
        // warnings = []
        // _.each ['ios', 'android'], (platform) =>
        //     screenshotTypes = appBrandingService.getScreenshotTypesForPlatform(platform)
        //     types = _.keys screenshotTypes
        //     _.each types, (type) =>
        //         filenames = appBrandingService.getScreenshotFilenamesOfType(branding, platform, type)
        //         if filenames.length is 0
        //             label = screenshotTypes[type].label
        //             if platform is 'android'
        //                 label = "Android #{label}"
        //             warnings.push label
        //
        // if warnings.length
        //     warnings.unshift 'At least one screenshot is required for:'
        //
        // warnings
        publishing: normalizedItem({
          id: 'store-publishing',
          label: 'Publishing'
        }),
        certificates: normalizedItem({
          id: 'store-certificates',
          label: 'Certificates'
        })
      }
    }
  };
  var getSectionTemplateUrl = function getSectionTemplateUrl(item) {
    return "/static/partials/apps/edit-section-".concat(item, ".html");
  };
  var allSubItems = groupSidebarItemsById($scope.vm.configSections);
  var initialSection = $location.search().section;
  $scope.vm.selectedItem = _.find(allSubItems, {
    id: initialSection
  }) || {
    id: 'dashboard'
  };
  $scope.selectSidebarItem = function (item) {
    if ($scope.vm.selectedItem && typeof $scope.vm.selectedItem.hasChanged === 'function' && $scope.vm.selectedItem.hasChanged()) {
      if (!confirm('You have unsaved changes. These will be lost. Continue?')) {
        return;
      }
      $scope.vm.branding = angular.fromJson(lastSavedBranding);
      setOwnerName();
      $scope.vm.theme = angular.fromJson(lastSavedTheme);
    }
    if (item.id !== 'dashboard' && !$scope.canEditApp) {
      return;
    }
    $scope.vm.selectedItem = item;
    $scope.vm.selectedItemTemplate = getSectionTemplateUrl(item.id);
    return $location.search('section', item.id);
  };

  /* Store info details */
  $scope.storeInfoForm = FORMS.storeInfo;
  $scope.storeUpdateUntilForm = FORMS.updateUntil;

  /* Invitations */
  $scope.invitationsCategoriesForm = FORMS.invitationsCategories;

  /* App Lock */
  $scope.appLockForm = FORMS.appLock;

  /* Screenshots */
  $scope.screenshotSizes = {
    android: {},
    ios: {}
  };
  _.each(['ios', 'android'], function (platform) {
    return _.each(_.keys(appBrandingService.getScreenshotTypesForPlatform(platform)), function (type) {
      $scope.screenshotSizes[platform][type] = appBrandingService.getAssetPreset("screenshot_".concat(platform, "_").concat(type));
    });
  });

  /* $scope API */
  $scope.brandingArtworkUrl = function () {
    if (branding.fp_ext_id) {
      return appBrandingService.getBrandingArtworkUrl(branding.fp_ext_id);
    } else {
      return undefined;
    }
  };
  $scope.save = $scope.saveBranding = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var whiteListedEventKey, branding;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if ($scope.canEditApp) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          whiteListedEventKey = 'invitations_config.only_whitelisted_events';
          branding = $scope.vm.branding;
          if (!((0, _lodash.get)(branding, whiteListedEventKey) && !(0, _lodash.get)(angular.fromJson(lastSavedBranding), whiteListedEventKey))) {
            _context.next = 13;
            break;
          }
          _context.prev = 5;
          _context.next = 8;
          return modalService.openConfirm({
            message: 'Changing "Hide non-linked events" configuration might log out users from the app if the events of this container do not have "Hide from other apps" option checked. Are you sure you want to continue?',
            okLabel: 'Continue'
          });
        case 8:
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](5);
          return _context.abrupt("return");
        case 13:
          $scope.saving = true;
          return _context.abrupt("return", appBrandingService.saveBranding(branding).then(function () {
            return $scope.setFlashMessage('Saved.');
          }, function () {
            return alert('An error occured while saving your settings.');
          }).then(getBranding).catch(function (err) {
            return console.error(err);
          }).finally(function () {
            return $scope.saving = false;
          }));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 10]]);
  }));
  $scope.saveTheme = function () {
    if (!$scope.canEditApp) {
      return;
    }
    $scope.saving = true;
    var fullTheme = appBrandingService.complicateTheme($scope.vm.theme);
    return appBrandingService.saveTheme(branding, fullTheme).then(function () {
      $scope.setFlashMessage('Saved.');
    }, function () {
      return $scope.setFlashMessage('An error occured while saving your settings.', 'danger');
    }).finally(function () {
      $scope.saving = false;
      return getBranding();
    });
  };
  $scope.canPublishApp = function () {
    if ($scope.selectItem && typeof $scope.selectItem.hasChanged === 'function' && $scope.selectItem.hasChanged()) {
      return false;
    }
    return !_.any(allSubItems, function (item) {
      return typeof item.warnings === 'function' ? item.warnings().length : undefined;
    });
  };
  $scope.sendPublishingRequest = function () {
    if (!$scope.canPublishApp()) {
      return alert('Please fill in all missing details before sending a request.');
    }
    return modalService.openModal({
      templateUrl: '/static/partials/apps/modal-create-publishing-request.html',
      scope: {
        request: {
          details: {},
          content: {}
        },
        contentRequest: {},
        requestFields: FORMS.createPublishingRequest,
        contentRequestFields: FORMS.contentRequest
      }
    }).then(function (request) {
      request.details.content = request.content;
      return appBrandingService.createPublishingRequest($scope.vm.branding, request.details).then(function () {
        $scope.setFlashMessage('Request sent.');
        $scope.selectSidebarItem({
          id: 'dashboard'
        });
        return $route.reload();
      }, function () {
        alert('An error occured while sending your request. Please try agian later.');
      });
    });
  };
  $scope.startBuild = function (type) {
    if (!type) {
      type = 'enterprise-build-both';
    }
    return appBrandingService.buildBranding(brandingId, {
      type: type
    }).then(function () {
      return $scope.setFlashMessage('Build launched.');
    }, function () {
      return alert('There was an error while triggering the build.');
    });
  };
  $scope.launchAJob = function () {
    return modalService.openModalWithForm({
      title: 'Start a job',
      fields: FORMS.buildJobs,
      saveLabel: 'Start',
      formCanBeSaved: function formCanBeSaved(model) {
        return model.type;
      }
    }).then(function (options) {
      return appBrandingService.buildBranding(brandingId, options);
    }).then(function () {
      return $scope.setFlashMessage('Build launched.');
    });
  };
  $scope.assignRequestToCurrentUser = function () {
    if (!$scope.vm.currentPublishingRequest) {
      return;
    }
    var currentUserId = userService.getCurrentUser()._id;
    var request = $scope.vm.currentPublishingRequest;
    if (request.assignee) {
      if (request.assignee === currentUserId) {
        return alert('You are already assigned to this request.');
      } else {
        if (!confirm("".concat(request.assignee, " is already assigned to this request. Are you sure you want to take over?"))) {
          return;
        }
      }
    }
    return appBrandingService.assignPublishingRequest(request._id, currentUserId).then(function () {
      $scope.vm.currentPublishingRequest.assignee = currentUserId;
      return $scope.setFlashMessage('You have been assigned.');
    }, function (err) {
      console.error(err);
      return alert('An error occured. Please try again later.');
    });
  };
  $scope.closePublishingRequest = function () {
    if (!$scope.vm.currentPublishingRequest) {
      return;
    }
    return appBrandingService.closePublishingRequest($scope.vm.currentPublishingRequest._id).then(function () {
      $scope.vm.currentPublishingRequest = null;
      return $scope.setFlashMessage('Closed.');
    }, function () {
      return alert('An error occured. Please try again later.');
    });
  };
  $scope.showPublishingRequestUpdateModal = function () {
    if (!$scope.vm.currentPublishingRequest) {
      return;
    }
    return modalService.openModalWithForm({
      title: 'Update publishing request',
      fields: FORMS.statusUpdate,
      saveLabel: 'Update',
      formCanBeSaved: function formCanBeSaved(model) {
        return model.status;
      }
    }).then(function (updates) {
      return appBrandingService.logChange(branding, _.extend(updates, {
        type: 'store-status',
        notify: $scope.vm.currentPublishingRequest.fp_owner
      })).then(function () {
        return $scope.setFlashMessage('Updated.');
      }, function () {
        return alert('An error occured. Please try again later.');
      });
    });
  };
  $scope.showStoreVersionsUpdateModal = function () {
    if (!$scope.userIsAppPublisher) {
      return;
    }
    return modalService.openModalWithForm({
      title: 'Store versions',
      fields: FORMS.storeVersions,
      model: angular.copy($scope.vm.branding.store || {}),
      saveLabel: 'Update'
    }).then(function (updates) {
      $scope.vm.branding.store = $scope.vm.branding.store || {};
      _.extend($scope.vm.branding.store, updates);
      return $scope.save();
    });
  };
  $scope.currentUserHasEvent = function (eid) {
    return ($scope.vm.userEventsIds || []).includes(eid) || !eid;
  };
  $scope.getLanguageName = function (lang) {
    return languages.getName(lang);
  };

  /* Init */
  var lastSavedBranding = null;
  var lastSavedTheme = null;
  $scope.brandingHasChanged = false;
  $scope.$watch(function () {
    return $scope.vm.branding && lastSavedBranding && angular.toJson($scope.vm.branding) !== lastSavedBranding;
  }, function (newValue) {
    $scope.brandingHasChanged = newValue;
  });
  $scope.themeHasChanged = false;
  $scope.$watch(function () {
    return $scope.vm.theme && lastSavedTheme && angular.toJson($scope.vm.theme) !== lastSavedTheme;
  }, function (newValue) {
    $scope.themeHasChanged = newValue;
  });
  $scope.$on('$destroy', function () {
    return $rootScope.currentBranding = null;
  });
  var getBranding = function getBranding() {
    return appBrandingService.getBranding(brandingId).then(function (resp) {
      resp.data.store_config = resp.data.store_config || {};
      appBrandingService.getPublishingAccount(resp.data.publishing_config.account).then(function (_ref2) {
        var data = _ref2.data;
        resp.data.publishing_config.name = data.name;
        angular.copy(resp.data, branding);
        $scope.attachments = (0, _attachments.getAttachmentNames)(branding);
        var updated = angular.copy($scope.vm);
        updated.branding = resp.data;
        $scope.vm = updated;
        setOwnerName();
        // we need this for inline i18n editors :(
        $rootScope.currentBranding = $scope.vm.branding;
        lastSavedBranding = angular.toJson(branding);
        $scope.brandingHasChanged = false;
        var binaryConfigurations = resp.data.binary_configurations;

        // Get the push notification certificates
        if (binaryConfigurations.ios && binaryConfigurations.ios.store && binaryConfigurations.ios.store.bundle_id) {
          $scope.certificatesStore = binaryConfigurations.ios.store.bundle_id;
          if ($scope.userIsAppPublisher) {
            appBrandingService.getPushCertificate(binaryConfigurations.ios.store.bundle_id).then(function (response) {
              $scope.certificates = null;
              if ((0, _attachments.hasAnyAttachments)(response.data)) {
                $scope.certificates = response.data;
                $scope.certificateAttachmentNames = (0, _attachments.getAttachmentNames)(response.data);
              }
            }, function () {
              return console.log('Failed to retrieve push certificates.');
            });
          }
        }
        appBrandingService.getTheme(branding).then(appBrandingService.simplifyTheme).then(function (theme) {
          $scope.vm.theme = theme;
          lastSavedTheme = angular.toJson(theme);
          return $scope.themeHasChanged = false;
        });
      });
    }, function (err) {
      console.error(err);
      return $scope.navigate('/apps');
    });
  };
  var getPublishingRequests = function getPublishingRequests() {
    return appBrandingService.getPublishingRequestsForBranding(brandingId).then(function (resp) {
      var lastRequest = resp.data[0];
      if (!lastRequest) {
        return $scope.canEditApp = true;
      }
      if (lastRequest.status !== 'closed') {
        $scope.vm.currentPublishingRequest = lastRequest;
      }
      return $scope.canEditApp = $scope.userIsAppPublisher ? true : !$scope.vm.currentPublishingRequest;
    }, function (err) {
      console.error(err);
      alert('There was an error retreving publishing requests. Editing has been disabled.');
      return $scope.canEditApp = false;
    });
  };
  var getPublishingAccounts = function getPublishingAccounts() {
    return appBrandingService.getAllPublishingAccounts().then(function (resp) {
      return $scope.vm.publishingAccounts = resp.data;
    });
  };
  $q.all([getBranding(), getPublishingRequests(), getPublishingAccounts()]).then(function () {
    if (initialSection) {
      return $scope.vm.selectedItemTemplate = getSectionTemplateUrl(initialSection);
    }
  });
  var unregister = $scope.$on('brandedAppManager:assetUploadComplete', getBranding);
  return $scope.$on('$destroy', unregister);
};
EditAppCtrl.$inject = ["$scope", "$route", "$routeParams", "$location", "$rootScope", "$q", "userService", "modalService", "appBrandingService", "accountService", "orgService"];
EditAppCtrl.$inject = ["$scope", "$route", "$routeParams", "$location", "$rootScope", "$q", "userService", "modalService", "appBrandingService", "accountService", "orgService"];
angular.module('backstage.controllers.brandedApps').controller('EditAppCtrl', EditAppCtrl);